import styled from "styled-components";
import { Colors } from "../../../../constants";

const Card = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  border-radius: 8px;
`;

export const DefaultCard = styled(Card)`
  background: rgba(38, 52, 101, 0.08);
`;

export const BadCard = styled(Card)`
  background:  rgba(211, 47, 47, 0.12);
`;

export const NormalCard = styled(Card)`
  background: rgba(237, 108, 2, 0.12);
`;

export const GoodCard = styled(Card)`
  background: rgba(46, 125, 50, 0.12);
`;

export const CardTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`;

export const TitleText = styled.div`
  color: rgba(0, 0, 0, 0.87);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
`;

export const CardContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const ContentText = styled.div`
  font-size: 24px;
  font-weight: 500;
`;

export const DefaultContentText = styled(ContentText)`
  color: rgba(0, 0, 0, 0.87);
`;

export const BadDefaultContentText = styled(ContentText)`
  color: ${Colors.DANGER}
`;

export const NormalDefaultContentText = styled(ContentText)`
  color: ${Colors.WARNING}
`;

export const GoodDefaultContentText = styled(ContentText)`
  color: #3B873E;
`;

const SecondContentText = styled.div`
  font-size: 14px;
  font-weight: 400;
`;

export const DefaultSecondContentText = styled(SecondContentText)`
  color: rgba(0, 0, 0, 0.87);
`;

export const BadDefaultSecondContentText = styled(SecondContentText)`
  color: ${Colors.DANGER}
`;

export const NormalDefaultSecondContentText = styled(SecondContentText)`
  color: ${Colors.WARNING}
`;

export const GoodDefaultSecondContentText = styled(SecondContentText)`
  color: #3B873E;
`;
